import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

const FormField = ({
  label,
  id,
  type,
  icon,
  style,
  callbackFn = null,
  onChange,
  min,
}) => {
  const [value, setValue] = useState("");

  const checkDateValidity = (inputValue) => {
    console.log(inputValue);
    console.log(new Date(inputValue));
    console.log(new Date(min));
    if (type === "date" && new Date(inputValue) < new Date(min)) {
      Swal.fire({
        icon: "error",
        title: "Ungültiges Datum",
        text: "Bitte geben Sie ein Datum ein, das heute oder später liegt.",
        allowOutsideClick: false,
      });
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    if (onChange) {
      onChange(e);
    }
    checkDateValidity(inputValue);
  };

  const handleBlur = () => {
    if (!checkDateValidity(value)) {
      setValue("");
    }
  };

  const handleFocus = (e) => {
    if (type === "date") {
      e.preventDefault();
    }
  };
  useEffect(() => {
    if (callbackFn) {
      callbackFn(value);
    }
    localStorage.setItem(id, JSON.stringify(value));
  }, [value, id, callbackFn]);

  return (
    <div className="form-floating" style={{ marginTop: 10 }}>
      <input
        type={type}
        className="form-control"
        id={id}
        placeholder={label}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleFocus}
        style={style}
        min={min}
      />
      <label htmlFor={id}>
        <i className={icon}></i> {label}
      </label>
    </div>
  );
};

export default FormField;
